export default "__VITE_ASSET__LL4iC0kd__"